import script from "./footer-links.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-links.vue?vue&type=script&setup=true&lang=js"

import "./footer-links.vue?vue&type=style&index=0&id=54a73a03&lang=scss"

const __exports__ = script;

export default __exports__